import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  brandingSelected: {},
  saveInProgress: false,
  staycastSettings: {},
  staycastParentSettings: {},
};

export const brandingSlice = createSlice({
  name: 'branding',
  initialState,
  reducers: {
    setBrandingSelected: (state, action) => {
      state.brandingSelected = action.payload;
    },
    setStaycastBrandingSelected: (state, action) => {
      const { settings, parentSettings } = action.payload;
      state.staycastSettings = settings;
      state.staycastParentSettings = parentSettings;
    },
    updateStaycastSettings(state, action) {
      const { settings } = action.payload;
      state.staycastSettings = settings;
    },
    setSaveInProgress: (state, action) => {
      state.saveInProgress = action.payload;
    },
    cleanBrandingSlice() {
      return initialState;
    },
  },
});

export const {
  cleanBrandingSlice,
  setBrandingSelected,
  setSaveInProgress,
  setStaycastBrandingSelected,
  updateStaycastSettings,
} = brandingSlice.actions;

export default brandingSlice.reducer;
